import { ComponentUtil } from '../../utils/ComponentUtil';
import { Hooks } from '../../types/Hooks';

ComponentUtil.loader(
  !!document.querySelector(Hooks.UWorkMasterData),
  () => import('./UWorkMasterData'),
  (UWorkMasterData) => {
    ComponentUtil.binder(Hooks.UWorkMasterData, UWorkMasterData);
  },
);
